import { FC } from 'react';
import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { Text } from '@frontend/design-system';
import { Category } from '../../../../../../types/form-template.types';
import { DropdownCategorizedChecklist } from './dropdown-categorized-checklist';
import { InlineCategorizedChecklist } from './inline-categorized-checklist';

const FIELD_OPTIONS_THRESHOLD = 5;

const categoryLabelStyle = css`
  font-weight: ${theme.font.weight.semibold};
  margin-bottom: ${theme.spacing(0.5)};
`;

const categoryContainerStyle = css`
  margin-top: ${theme.spacing(1)};
`;

interface CategorizedChecklistProps {
  category: Category;
  fieldId: string;
  value: string[];
  onChange: (newValue: string[]) => void;
  onBlur: () => void;
  hasError: boolean;
}

export const CategorizedChecklist: FC<CategorizedChecklistProps> = ({
  category,
  fieldId,
  value,
  onChange,
  onBlur,
  hasError,
}) => {
  const options = category.options ?? [];
  const shouldShowDropdown = options.length > FIELD_OPTIONS_THRESHOLD;

  return (
    <div css={categoryContainerStyle}>
      <Text css={categoryLabelStyle}>{category.name}</Text>
      {shouldShowDropdown ? (
        <DropdownCategorizedChecklist
          categoryId={category.id}
          options={options}
          fieldId={fieldId}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          hasError={hasError}
        />
      ) : (
        <InlineCategorizedChecklist
          categoryId={category.id}
          options={options}
          fieldId={fieldId}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
        />
      )}
    </div>
  );
};
